import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainNavBar from "../../Components/Navbar/NavBar";
import TopNavbar from "../../Components/TopNavbar/TopNavbar";
import RoutsPages from "../RoutsPages";

const Dashboard = ({ switchTheme, mainUser }) => {
    const dispatch = useDispatch();
    const MAIN_USER = mainUser ? mainUser?.data : "";

    const { active, smallSize } = useSelector((state) => state.switch);
    const smallSizevalue = smallSize;

    const [xsSmallSize, setxsSmallsize] = useState(false);

    const handelResize = () => {
        if (window.innerWidth <= 1200) {
            setxsSmallsize(false);
        } else setxsSmallsize(true);
    };

    useEffect(() => {
        handelResize();
    }, []);

    useEffect(() => {
        if (smallSizevalue != null) {
            setxsSmallsize(!xsSmallSize);
        }
    }, [smallSizevalue]);

    window.addEventListener("resize", handelResize);
    return (
        <>
            <Grid container columns={12}>
                {xsSmallSize && (
                    <Grid item xs={xsSmallSize ? (active ? 2 : 1) : 12}>
                        <MainNavBar active={active} MAIN_USER={MAIN_USER} />
                    </Grid>
                )}
                <Grid item xs={xsSmallSize ? (active ? 10 : 11) : 12}>
                    <TopNavbar
                        switchTheme={switchTheme}
                        MAIN_USER={MAIN_USER}
                    />
                    <RoutsPages />
                </Grid>
            </Grid>
        </>
    );
};

export default Dashboard;
